module.exports = __webpack_public_path__ + "img/3T5.34a3841c.png";